// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileIconDefault__progress-cb5c01,
.FileIconDefault__infinity-e4dd9b {
  stroke: var(--addition-50);
  stroke-linecap: round;
  fill: transparent;
  transform-box: fill-box;
  transform-origin: center;
  stroke-width: 2px;
}

.FileIconDefault__progress-cb5c01 {
  transform: rotate(-90deg);
  stroke-dasharray: 100;
}

.FileIconDefault__infinity-e4dd9b {
  animation: FileIconDefault__dash-bb56e4 1.5s ease-in-out infinite, FileIconDefault__rotate-a56a12 2s linear infinite;
}

.FileIconDefault__pointer-a3bc9d {
  cursor: pointer;
}

.FileIconDefault__text-ce5687 {
  font-size: 13px;
  fill: var(--addition-50);
  letter-spacing: var(--font-spacing-body-1);
}

.FileIconDefault__file-error-icon-0-b32dc9,
.FileIconDefault__file-error-icon-10-d1d7b6,
.FileIconDefault__file-error-icon-20-e2b0a0,
.FileIconDefault__file-error-icon-30-c51f65,
.FileIconDefault__file-error-icon-40-b6fb60,
.FileIconDefault__file-error-icon-50-ae2301,
.FileIconDefault__file-error-icon-60-d84c63,
.FileIconDefault__file-error-icon-70-d4adcc,
.FileIconDefault__file-error-icon-80-f2b971,
.FileIconDefault__file-error-icon-90-fc3494,
.FileIconDefault__file-error-icon-100-ab24bf,
.FileIconDefault__file-error-icon-110-c1ca5b,
.FileIconDefault__file-error-icon-120-accd7a,
.FileIconDefault__file-error-icon-130-aa9a3a {
  fill: var(--danger-40);
}

.FileIconDefault__file-0-dc4b70 {
  fill: var(--file-0);
}

.FileIconDefault__file-10-f4d84d {
  fill: var(--file-10);
}

.FileIconDefault__file-20-eb6b36 {
  fill: var(--file-20);
}

.FileIconDefault__file-30-be6a4c {
  fill: var(--file-30);
}

.FileIconDefault__file-40-dd72eb {
  fill: var(--file-40);
}

.FileIconDefault__file-50-df1c41 {
  fill: var(--file-50);
}

.FileIconDefault__file-60-b1cc85 {
  fill: var(--file-60);
}

.FileIconDefault__file-70-a31051 {
  fill: var(--file-70);
}

.FileIconDefault__file-80-fff354 {
  fill: var(--file-80);
}

.FileIconDefault__file-90-c0c618 {
  fill: var(--file-90);
}

.FileIconDefault__file-100-bab239 {
  fill: var(--file-100);
}

.FileIconDefault__file-110-b288c1 {
  fill: var(--file-110);
}

.FileIconDefault__file-120-d694db {
  fill: var(--file-120);
}

.FileIconDefault__file-130-a3f50b {
  fill: var(--brand-primary-40);
}

@keyframes FileIconDefault__rotate-a56a12 {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes FileIconDefault__dash-bb56e4 {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/FileIcon/FileIconDefault/FileIconDefault.styles.m.css"],"names":[],"mappings":"AAAA;;EAEE,0BAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,wBAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,oHAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;;;;;;;;;;;;;;EAcE,sBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE;IACE,wBAAA;IACA,oBAAA;EAAF;EAEA;IACE,yBAAA;IACA,sBAAA;EAAF;EAEA;IACE,yBAAA;IACA,uBAAA;EAAF;AACF","sourcesContent":[".progress,\n.infinity {\n  stroke: var(--addition-50);\n  stroke-linecap: round;\n  fill: transparent;\n  transform-box: fill-box;\n  transform-origin: center;\n  stroke-width: 2px;\n}\n\n.progress {\n  transform: rotate(-90deg);\n  stroke-dasharray: 100;\n}\n\n.infinity {\n  animation: dash 1.5s ease-in-out infinite, rotate 2s linear infinite;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.text {\n  font-size: 13px;\n  fill: var(--addition-50);\n  letter-spacing: var(--font-spacing-body-1);\n}\n\n.file-error-icon-0,\n.file-error-icon-10,\n.file-error-icon-20,\n.file-error-icon-30,\n.file-error-icon-40,\n.file-error-icon-50,\n.file-error-icon-60,\n.file-error-icon-70,\n.file-error-icon-80,\n.file-error-icon-90,\n.file-error-icon-100,\n.file-error-icon-110,\n.file-error-icon-120,\n.file-error-icon-130 {\n  fill: var(--danger-40);\n}\n\n.file-0 {\n  fill: var(--file-0);\n}\n\n.file-10 {\n  fill: var(--file-10);\n}\n\n.file-20 {\n  fill: var(--file-20);\n}\n\n.file-30 {\n  fill: var(--file-30);\n}\n\n.file-40 {\n  fill: var(--file-40);\n}\n\n.file-50 {\n  fill: var(--file-50);\n}\n\n.file-60 {\n  fill: var(--file-60);\n}\n\n.file-70 {\n  fill: var(--file-70);\n}\n\n.file-80 {\n  fill: var(--file-80);\n}\n\n.file-90 {\n  fill: var(--file-90);\n}\n\n.file-100 {\n  fill: var(--file-100);\n}\n\n.file-110 {\n  fill: var(--file-110);\n}\n\n.file-120 {\n  fill: var(--file-120);\n}\n\n.file-130 {\n  fill: var(--brand-primary-40);\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progress": `FileIconDefault__progress-cb5c01`,
	"infinity": `FileIconDefault__infinity-e4dd9b`,
	"dash": `FileIconDefault__dash-bb56e4`,
	"rotate": `FileIconDefault__rotate-a56a12`,
	"pointer": `FileIconDefault__pointer-a3bc9d`,
	"text": `FileIconDefault__text-ce5687`,
	"file-error-icon-0": `FileIconDefault__file-error-icon-0-b32dc9`,
	"fileErrorIcon0": `FileIconDefault__file-error-icon-0-b32dc9`,
	"file-error-icon-10": `FileIconDefault__file-error-icon-10-d1d7b6`,
	"fileErrorIcon10": `FileIconDefault__file-error-icon-10-d1d7b6`,
	"file-error-icon-20": `FileIconDefault__file-error-icon-20-e2b0a0`,
	"fileErrorIcon20": `FileIconDefault__file-error-icon-20-e2b0a0`,
	"file-error-icon-30": `FileIconDefault__file-error-icon-30-c51f65`,
	"fileErrorIcon30": `FileIconDefault__file-error-icon-30-c51f65`,
	"file-error-icon-40": `FileIconDefault__file-error-icon-40-b6fb60`,
	"fileErrorIcon40": `FileIconDefault__file-error-icon-40-b6fb60`,
	"file-error-icon-50": `FileIconDefault__file-error-icon-50-ae2301`,
	"fileErrorIcon50": `FileIconDefault__file-error-icon-50-ae2301`,
	"file-error-icon-60": `FileIconDefault__file-error-icon-60-d84c63`,
	"fileErrorIcon60": `FileIconDefault__file-error-icon-60-d84c63`,
	"file-error-icon-70": `FileIconDefault__file-error-icon-70-d4adcc`,
	"fileErrorIcon70": `FileIconDefault__file-error-icon-70-d4adcc`,
	"file-error-icon-80": `FileIconDefault__file-error-icon-80-f2b971`,
	"fileErrorIcon80": `FileIconDefault__file-error-icon-80-f2b971`,
	"file-error-icon-90": `FileIconDefault__file-error-icon-90-fc3494`,
	"fileErrorIcon90": `FileIconDefault__file-error-icon-90-fc3494`,
	"file-error-icon-100": `FileIconDefault__file-error-icon-100-ab24bf`,
	"fileErrorIcon100": `FileIconDefault__file-error-icon-100-ab24bf`,
	"file-error-icon-110": `FileIconDefault__file-error-icon-110-c1ca5b`,
	"fileErrorIcon110": `FileIconDefault__file-error-icon-110-c1ca5b`,
	"file-error-icon-120": `FileIconDefault__file-error-icon-120-accd7a`,
	"fileErrorIcon120": `FileIconDefault__file-error-icon-120-accd7a`,
	"file-error-icon-130": `FileIconDefault__file-error-icon-130-aa9a3a`,
	"fileErrorIcon130": `FileIconDefault__file-error-icon-130-aa9a3a`,
	"file-0": `FileIconDefault__file-0-dc4b70`,
	"file0": `FileIconDefault__file-0-dc4b70`,
	"file-10": `FileIconDefault__file-10-f4d84d`,
	"file10": `FileIconDefault__file-10-f4d84d`,
	"file-20": `FileIconDefault__file-20-eb6b36`,
	"file20": `FileIconDefault__file-20-eb6b36`,
	"file-30": `FileIconDefault__file-30-be6a4c`,
	"file30": `FileIconDefault__file-30-be6a4c`,
	"file-40": `FileIconDefault__file-40-dd72eb`,
	"file40": `FileIconDefault__file-40-dd72eb`,
	"file-50": `FileIconDefault__file-50-df1c41`,
	"file50": `FileIconDefault__file-50-df1c41`,
	"file-60": `FileIconDefault__file-60-b1cc85`,
	"file60": `FileIconDefault__file-60-b1cc85`,
	"file-70": `FileIconDefault__file-70-a31051`,
	"file70": `FileIconDefault__file-70-a31051`,
	"file-80": `FileIconDefault__file-80-fff354`,
	"file80": `FileIconDefault__file-80-fff354`,
	"file-90": `FileIconDefault__file-90-c0c618`,
	"file90": `FileIconDefault__file-90-c0c618`,
	"file-100": `FileIconDefault__file-100-bab239`,
	"file100": `FileIconDefault__file-100-bab239`,
	"file-110": `FileIconDefault__file-110-b288c1`,
	"file110": `FileIconDefault__file-110-b288c1`,
	"file-120": `FileIconDefault__file-120-d694db`,
	"file120": `FileIconDefault__file-120-d694db`,
	"file-130": `FileIconDefault__file-130-a3f50b`,
	"file130": `FileIconDefault__file-130-a3f50b`
};
module.exports = ___CSS_LOADER_EXPORT___;
